import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoLiberacaoRemota({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'operacaoliberacaoremotas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoLiberacaoRemota({ payload }) {
  try {
    const { idoperacaoabastecimento, params } = payload;

    yield call(
      api.delete,
      `operacaoliberacaoremotas/${idoperacaoabastecimento}`
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

//Não vai ser necessário porque esse não vai ter edição
export function* store({ payload }) {
  try {
    const { operacaoliberacaoremota, params } = payload;

    yield call(api.post, 'operacaoliberacaoremotas', operacaoliberacaoremota);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    //history.push('/operacaoabastecimento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { movi_codigo } = payload;

    const { data } = yield call(
      api.get,
      `operacaoliberacaoremotas/${movi_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoliberacaoremota, params } = payload;

    yield call(api.put, 'operacaoliberacaoremotas', operacaoliberacaoremota);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operacaoabastecimento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'operacaoliberacaoremotas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoliberacaoremota/OPERACAOLIBERACAOREMOTA_IN_REQUEST',
    requestOperacaoLiberacaoRemota
  ),
  takeLatest(
    '@operacaoliberacaoremota/DELETE_OPERACAOLIBERACAOREMOTA',
    deleteOperacaoLiberacaoRemota
  ),
  takeLatest(
    '@operacaoliberacaoremota/SUCCESS_REMOVE',
    requestOperacaoLiberacaoRemota
  ),
  takeLatest('@operacaoliberacaoremota/STORE_OPERACAOLIBERACAOREMOTA', store),
  takeLatest('@operacaoliberacaoremota/FIND_OPERACAOLIBERACAOREMOTA', find),
  takeLatest('@operacaoliberacaoremota/UPDATE_OPERACAOLIBERACAOREMOTA', update),
  takeLatest('@operacaoliberacaoremota/RECORD_FILTERING', applyedFilters),
]);
